__turbopack_context__.v({
  "accordionHeaderText": "FolderTreeItem-module__tywO6G__accordionHeaderText",
  "caretContainer": "FolderTreeItem-module__tywO6G__caretContainer",
  "expandIcon": "FolderTreeItem-module__tywO6G__expandIcon",
  "expandIconClosed": "FolderTreeItem-module__tywO6G__expandIconClosed",
  "expandIconOpen": "FolderTreeItem-module__tywO6G__expandIconOpen",
  "folderItem": "FolderTreeItem-module__tywO6G__folderItem",
  "folderItemIcon": "FolderTreeItem-module__tywO6G__folderItemIcon",
  "folderItemSelected": "FolderTreeItem-module__tywO6G__folderItemSelected",
  "folderItemText": "FolderTreeItem-module__tywO6G__folderItemText",
});
